module.exports = __webpack_public_path__ + "static/media/Image5.ab8fe82b.JPG";